export enum WallConsts {
  INITIAL_WIDTH = 5500,
  INITIAL_HEIGHT = 2500,
  INITIAL_SOCKEL = 150,
  WIDTH_MIN = 3000,
  WIDTH_MAX = 10000,
}
